import { ROOM_CODE_ALPHABET, ROOM_CODE_LENGTH } from '@webfile/protocol'

/** Same-origin share link used by clipboard + QR. Preserves auth query params. */
export function buildRoomShareUrl(code: string, loc: Location = location): string {
  const normalized = normalizeRoomCode(code)
  const url = new URL(loc.href)
  url.searchParams.set('room', normalized)
  // Keep existing query params (e.g. eo_token / eo_time for EdgeOne preview auth)
  return url.toString()
}

export function normalizeRoomCode(raw: string): string {
  return String(raw || '')
    .trim()
    .toUpperCase()
}

/** Accept 4–8 alnum (server) while primary codes are 6 from ROOM_CODE_ALPHABET. */
export function isValidRoomCode(code: string): boolean {
  const c = normalizeRoomCode(code)
  return /^[A-Z0-9]{4,8}$/.test(c)
}

/** Parse bare code or full URL containing ?room=. */
export function extractRoomCode(input: string): string | null {
  const raw = String(input || '').trim()
  if (!raw) return null
  try {
    if (raw.includes('://') || raw.startsWith('?') || raw.includes('room=')) {
      const url = raw.includes('://')
        ? new URL(raw)
        : new URL(raw.startsWith('?') ? raw : `?${raw}`, 'http://local.invalid')
      const fromQuery = url.searchParams.get('room')
      if (fromQuery && isValidRoomCode(fromQuery)) return normalizeRoomCode(fromQuery)
    }
  } catch {
    /* fall through */
  }
  const bare = normalizeRoomCode(raw)
  if (isValidRoomCode(bare)) return bare
  return null
}

export function roomCodeHint(): string {
  return `${ROOM_CODE_LENGTH} 位，不含 0/O/1/I/L`
}

export { ROOM_CODE_ALPHABET, ROOM_CODE_LENGTH }
